import { getReportTemplates } from "../../api/endpoints/reportTemplates";
import { createQuery } from "./apiHooks";

export const useGetReportTemplates = createQuery(getReportTemplates, {
  queryKey: ["ReportTemplates", "Get"],
});
